export const windowIdentifierKey = "X-WI";
/**
 * @description save token into localStorage
 */
export const getWindowIdentifier = (): string => {
  let value = window.localStorage.getItem(windowIdentifierKey);
  if (!value || "undefined" === value) {
    value = generateWindowIdentifier();

    window.localStorage.setItem(windowIdentifierKey, value);
  }

  return value;
};

/**
 * @description remove token form localStorage
 */
const generateWindowIdentifier = (): string => {
  return [...Array(30)].map(() => Math.random().toString(36)[2]).join("");
};
